import React, { useEffect, useState, useMemo } from "react";
import SelectInput from "./../../components/common/ui/Inputs/SelectInput";
import { TextInput } from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import Table from "../../components/common/table/Table";
import { useDispatch, useSelector } from "react-redux";
import { PODAction } from "../../_store/pod.slice";
import { logReportAction, masterActions } from "../../_store";
import { history } from "../../_helpers";
import { IpActivityAction } from "../../_store/ipActivity.slice";
import generateXlsx from "../../components/common/export/generateXlsx";
import RedIcon from "../../assets/KioRed.png";
import OrangeIcon from "../../assets/KioOrange.png";
import CustomLoader from "../../components/common/ui/Loader";

// Constants for default values
const DEFAULT_SHARED_POD = 2;
const DEFAULT_FLAG_STATUS = "0";
const DEFAULT_PAGE_NO = 1;
const DEFAULT_ROW_COUNT_PER_PAGE = 10;
function IPList() {
  const dispatch = useDispatch();

  const { facilityDropDown: facilityDropDownOption } = useSelector(
    (state) => state.master
  );
  const isPageReloading = useSelector((state) => state.master?.isPageReload);
  const [showSearchFields, setShowSearchFields] = useState(true);
  const { flagOptions } = useSelector((state) => state.dropdownOptions);

  const {
    getipActivityList: reduxipActivityList,
    ipActivitylistloading,
    getipActivityListFullList,
    ipSearchdata,
  } = useSelector((x) => x.ipActivity);

  const shouldShowExcelExport = reduxipActivityList[0]?.TotalCount;

  const ipActivityInput = ipSearchdata;

  // Load facility dropdown on component mount
  useEffect(() => {
    const loadFacilities = async () => {
      try {
        await dispatch(
          masterActions.LoadFacilityDropDown({
            FacilityID: 0,
            ActiveStatus: 1,
          })
        );
      } catch (error) {
        console.error("Error loading facilities:", error);
        // Optionally dispatch an error action or show a notification
      }
    };
    loadFacilities();
  }, [dispatch]);

  // Dispatch the action when FacilityID changes in loadManagementUser
  useEffect(() => {
    if (ipActivityInput?.FacilityID === 0) return;
    dispatch(IpActivityAction.LoadIPActivityList({ ...ipActivityInput }));
  }, [
    ipActivityInput?.RowCountPerPage,
    ipActivityInput?.PageNo,
    ipActivityInput?.FacilityID,
    ipActivityInput?.FlagName,
    //isPageReloading,
  ]);

  // Column configuration for the table
  const columns = useMemo(() => [
    {
      name: "IP Address",
      key: "IPAddress",
      selector: (row) => row.IPAddress,
      sortable: true,
      cell: (row) => (
        <div
          onClick={() => navigateToIPDetails(row)}
          className="Common_Link_Style"
        >
          {row.IPAddress}
        </div>
      ),
    },
    {
      name: "Public User Count",
      key: "PUCount",
      selector: (row) => row.PUCount,
      sortable: true,
    },
    {
      name: "Flag",
      key: "FlagName",
      selector: (row) => row.FlagName,
      cell: (row) => (
        <div
          className={row.FlagName === "RED" ? "red-flag" : "yellow-flag"}
          title={row.FlagName === "RED" ? "RED" : "Orange"}
        >
          {row.FlagName === "RED" ? (
            <i
              className="fa fa-flag ip-flagged-message red-flag"
              aria-hidden="true"
            ></i>
          ) : (
            <i
              className="fa fa-flag ip-flagged-message yellow-flag"
              aria-hidden="true"
            ></i>
          )}
        </div>
      ),
      sortable: true,
      center: true,
    },
  ]);

  // Function to handle the selection of a POD code and navigate to the Edit page
  const navigateToIPDetails = (row) => {
    const IPAddress = row;

    if (!IPAddress) return; // Early return to exit if PodID is invalid

    history.navigate("/Admin/IPActivityList/Details", {
      state: {
        ipAddressState: IPAddress,
        FacilityID: ipActivityInput?.FacilityID,
      }, // Pass the ID securely using state
    });
  };

  //The function effectively updates the state based on input changes.
  const updateFormField = (e) => {
    // Ensure e.target is defined to prevent destructuring errors
    const { target } = e || {};

    if (!target) return; // Exit if target is not available

    const { name, value } = target;

    const params = { ...ipSearchdata, [name]: value };
    dispatch(IpActivityAction.setIPSearch(params));
  };

  const updateSelectedOption = (selectedOption, name) => {
    const updatedParams = {
      ...ipActivityInput,
      PageNo: 1,
      RowCountPerPage: 10,
      [name]:
        name === "FlagName"
          ? selectedOption?.value ?? "0"
          : selectedOption?.value ?? 0,
    };

    dispatch(IpActivityAction.setIPSearch(updatedParams));
  };

  // Function to reset the state to default values for the IpActivityList
  const resetIpActivityList = () => {
    // Define the default state values for reset
    const resetState = {
      IpAddress: "",
      FlagName: "0",
      FacilityID: 0,
      PageNo: DEFAULT_PAGE_NO,
      RowCountPerPage: DEFAULT_ROW_COUNT_PER_PAGE,
      sortField: "",
    };
    dispatch(IpActivityAction.setIPSearch(resetState));
    // Set the state with reset values
    if (resetState?.FacilityID === 0) return;
    dispatch(IpActivityAction.LoadIPActivityList({ ...resetState }));
  };

  // Function to handle form submission
  const handlePODSearchSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    const search = { ...ipActivityInput, PageNo: 1, RowCountPerPage: 10 };
    dispatch(IpActivityAction.setIPSearch(search));
    if (ipActivityInput?.FacilityID === 0) return;
    dispatch(IpActivityAction.LoadIPActivityList(search));
  };
  // Function to export POD data into an Excel file with specified columns and formatting.
  useEffect(() => {
    if (getipActivityListFullList?.DataList?.length > 0) {
      // Define the title of the Excel sheet
      const title = "PublicUsers_IPActivity";

      // Define the column headers for Excel
      const generateExcelColumns = ["IP Address", "Public User Count", "Flag"];
      // Map the data for Excel
      const docList = getipActivityListFullList?.DataList?.map((obj) => ({
        IPAddress: obj.IPAddress,
        PublicUserCount: obj.PUCount,
        Flag: obj.FlagName,
      }));

      // Check if there is data before generating the Excel
      try {
        generateXlsx(docList, generateExcelColumns, title);
        dispatch(IpActivityAction.clearipActivityListFullList());
      } catch (error) { }
    }
  }, [getipActivityListFullList]);

  const exportPODDataToExcel = () => {
    const updateTotalRows = {
      ...ipActivityInput,
      RowCountPerPage: reduxipActivityList?.TotalRecordCount,
      exportExcel: true,
      PageNo: 1,
    };

    // Dispatch and process the response
    dispatch(IpActivityAction?.LoadIPActivityList(updateTotalRows));
    // .then((response) => {
    //   // Ensure fullPODData and DataList are valid
    //   const { DataList = [] } = response.payload || {}; // Assuming response contains DataList directly
  };

  //Sorting

  let isSorting = false; // to restrict the pagination issue
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;

    isSorting = true;
    const search = { ...ipSearchdata };
    const newSortOrder = search?.sortField?.includes(column.key)
      ? search.sortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.sortField = `${column.key} ${newSortOrder}`;
    dispatch(IpActivityAction.setIPSearch(search));
    dispatch(
      IpActivityAction.LoadIPActivityList({
        ...ipSearchdata,
        sortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  // Updates the number of rows per page in the POD list data
  const handleRowCountChange = (newRowCount) => {
    const params = { ...ipSearchdata, RowCountPerPage: newRowCount, PageNo: 1 };
    dispatch(IpActivityAction.setIPSearch(params));
  };

  // Handles page change for the POD list
  const handlePageChange = (newPage) => {
    if (isSorting) {
      isSorting = false;
      return;
    }
    const params = { ...ipSearchdata, PageNo: newPage };
    dispatch(IpActivityAction.setIPSearch(params));
  };

  if (ipActivitylistloading) return <CustomLoader />;

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form onSubmit={handlePODSearchSubmit}>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="FacilityID"
                label="Facility Code"
                options={facilityDropDownOption}
                value={ipActivityInput?.FacilityID}
                handleChange={(selectedOption) =>
                  updateSelectedOption(selectedOption, "FacilityID")
                }
                //required={true}
                isMulti={false}
                isClearable={ipActivityInput?.FacilityID !== 0}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="IpAddress"
                id="IpAddress"
                label="IP Address"
                value={ipActivityInput?.IpAddress}
                handleChange={updateFormField}
                placeholder="IP Address"
                maxLength={30}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                options={flagOptions}
                value={ipActivityInput?.FlagName ?? "0"} // Default to 2 if undefined
                handleChange={(selectedOption) =>
                  updateSelectedOption(selectedOption, "FlagName")
                }
                name="FlagName"
                isMulti={false}
                closeMenuOnSelect
                placeholder="--ALL--"
                label="Flag"
                isClearable={ipActivityInput?.FlagName !== "0"}
              />
            </div>
          </div>
        </div>
        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
          <Button
            variant="primary"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          ></Button>
          <Button
            variant="secondary"
            className="me-2"
            onClick={() => {
              resetIpActivityList();
            }}
            label={"RESET"}
            icon={"fa-solid fa-rotate-right"}
            type={"button"}
            status={"secondary"}
            disabled={false}
          />
        </div>
      </form>
    );
  };

  return (
    <div>
      <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
        <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
          {/* Mobile only (Below md breakpoint) */}
          <div className=" d-block d-md-none">
            <div
              className=" d-flex align-items-center justify-content-between"
              style={{ background: "transparent", cursor: "pointer" }}
              onClick={toggleInformation}
            >
              <h2 className="form_title_uppercase text-color">
                IP Activity search
              </h2>
              <i
                id="itagInformation"
                className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                  }`}
                style={{ fontSize: "20px" }}
              ></i>
            </div>
          </div>
          {/* Mobile only (Below md breakpoint) */}
          <div className="d-block d-md-none mt-2">
            {showSearchFields && renderSearch()}
          </div>

          {/* Web only (Desktop and above) */}
          <div className="mb-3 d-none d-md-block">
            <h2 className="form_title_uppercase text-color">
              IP Activity search
            </h2>
          </div>
          {/* Web only (Desktop and above) */}
          <div className="d-none d-md-block">{renderSearch()}</div>
        </div>
        {ipActivityInput.FacilityID === 0 ? (
          <div className=" mt-4 w-100">
            <div className="text-center">
              <b className="table-no-data-text mt-5 fs-4 mb-5">
                Select any one of the Facility Code in the dropdown list
              </b>
            </div>
          </div>
        ) : (
          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
            {reduxipActivityList?.DataList?.length > 0 && (
              <>
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 gap-3">
                  <div className="col-lg-12 row">
                    <div className="d-flex align-items-center text fs-5 col-lg-6 col-md-6 col-sm-12">
                      <i
                        className="fa fa-flag ip-flagged-message red-flag me-2"
                        aria-hidden="true"
                      ></i>
                      Public Users who have the same IP address and connected
                      with the same inmate.
                    </div>
                    <div className="d-flex align-items-center text fs-5 col-lg-6 col-md-6 col-sm-12">
                      <i
                        className="fa fa-flag ip-flagged-message yellow-flag me-2"
                        aria-hidden="true"
                      ></i>
                      Public Users who have the same IP address and connected
                      with different inmates or no inmates.
                    </div>
                  </div>
                </div>
                {reduxipActivityList && (
                  <div className="d-flex flex-wrap justify-content-end align-items-center mb-2 gap-3">
                    <ExcelExport
                      variant="soft-gray"
                      handleExcelExport={exportPODDataToExcel}
                    />
                  </div>
                )}
              </>
            )}
            <Table
              columns={columns}
              data={reduxipActivityList?.DataList}
              pagination
              onChangeRowsPerPage={handleRowCountChange}
              onChangePage={handlePageChange}
              totalRowCount={reduxipActivityList?.TotalRecordCount}
              currentPage={ipActivityInput?.PageNo}
              paginationPerPage={ipActivityInput.RowCountPerPage}
              serverSideSort
              onSort={handleSort}
              sortColumn={ipActivityInput?.sortField?.split(" ")[0]}
              sortDirection={ipActivityInput?.sortField?.split(" ")[1]}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default React.memo(IPList);
